import {useAppSelector} from '@/hooks';
import {isPageVideo} from '@Components/poster-editor/poster-editor-reducer';

export const useIsCurrentPageVideo = (): boolean => {
  const currentPageId = useAppSelector((state) => {
    return state.posterEditor.currentPageId;
  });

  return useAppSelector((state) => {
    return isPageVideo(state, currentPageId);
  });
};
